/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const SET_HIDE_ADULT_CONTENT_SETTING_VERTICAL_LIMIT =
    'SET_HIDE_ADULT_CONTENT_SETTING_VERTICAL_LIMIT';
export const SET_HIDE_ADULT_CONTENT_STATE = 'SET_HIDE_ADULT_CONTENT_STATE';
export const SET_HIDE_ADULT_CONTENT_SETTING_HIGHLIGHT_POSITION =
    'SET_HIDE_ADULT_CONTENT_SETTING_HIGHLIGHT_POSITION';
